<template>
  <div class="container add-listing-page">
    <h3>Service Listing</h3>
    <p>
      For service listings, you can visit your profile page and fill out the "Company / Services
      Settings" section.
      <router-link
        to="/profile"
        class="nav-link"
      >
        Go to profile page
      </router-link>
    </p>
  </div>
</template>

<script setup></script>

<style scoped>
  .add-listing-page {
    max-width: 600px;
    margin: 0 auto;
    margin-top: 20px;
    padding: 20px;
    border: 1px solid #ccc;
    border-radius: 8px;
    background-color: #f9f9f9;
  }
</style>
